// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"ModalOTP_modalFooter__3shVN"};